import { render, staticRenderFns } from "./DistributionOfStartupCostsChart.vue?vue&type=template&id=2283358d"
import script from "./DistributionOfStartupCostsChart.vue?vue&type=script&lang=js"
export * from "./DistributionOfStartupCostsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports